module.exports = __webpack_public_path__ + "img/正在作业人数占比@3x.819c08b8.png";